import { useState } from "react";
import { Paper, Typography, Grid, Button } from "@mui/material";
import SettingSwitch from "../components/SettingsSwitch";
import PitchConfiguration from "../components/PitchConfiguration";
import VoteConfiguration from "../components/VoteConfiguration";

const PitchSettings = ({ settings, handleChange }) => {
  const [pitchConfigOpen, setPitchConfigOpen] = useState(false);
  const [voteConfigOpen, setVoteConfigOpen] = useState(false);
  return (
    <Paper sx={{ p: 3 }}>
      <Typography variant="subtitle1" sx={{ mb: 2 }}>
        Pitch / Voting Settings
      </Typography>

      <Typography variant="caption" sx={{ display: "block", mb: 3 }}>
        Pitch events and voting functionality
      </Typography>

      <Grid container spacing={1}>
        {/* Display Event */}
        <Grid item xs={12}>
          <SettingSwitch
            label="Enabled"
            checked={settings?.pitches?.enabled}
            onChange={() =>
              handleChange("pitches.enabled", !settings?.pitches?.enabled)
            }
            description=""
          />
        </Grid>

        {/* Wait List Enabled */}
        {settings?.pitches?.enabled && (
          <Grid item xs={12}>
            <Button variant="outlined" onClick={() => setPitchConfigOpen(true)}>
              Configure Pitches
            </Button>
          </Grid>
        )}

        {/* Track Attendee Presence */}
        {settings?.pitches?.enabled && (
          <Grid item xs={12}>
            <SettingSwitch
              label="Voting"
              checked={settings?.pitches?.voting}
              onChange={() =>
                handleChange("pitches.voting", !settings?.pitches?.voting)
              }
              description=""
            />
          </Grid>
        )}
        {/* {settings?.pitches?.voting && (
          <Grid item xs={12}>
            <Button variant="outlined" onClick={() => setVoteConfigOpen(true)}>
              Configure Voting
            </Button>
          </Grid>
        )} */}
      </Grid>
      <PitchConfiguration
        open={pitchConfigOpen}
        close={() => setPitchConfigOpen(false)}
        votingEnabled={!!settings?.pitches?.voting}
      />
      <VoteConfiguration
        open={voteConfigOpen}
        close={() => setVoteConfigOpen(false)}
      />
    </Paper>
  );
};

export default PitchSettings;
